import { IStorageAdapter } from './IStorageAdapter';
import { ApiResponse } from '../../types/api';
import { Attachment, UploadAttachmentDto, AttachmentFilter } from '../../types/attachment';
import { ApiClient as apiClient } from '../apiClient';

export class LaravelStorageAdapter implements IStorageAdapter {
  private readonly BASE = '/api/attachments';

  async upload(dto: UploadAttachmentDto): Promise<ApiResponse<Attachment>> {
    const formData = new FormData();
    formData.append('file', dto.file);
    formData.append('entity_type', dto.entity_type);
    formData.append('entity_id', dto.entity_id);
    formData.append('file_category', dto.file_category);
    if (dto.notes) formData.append('notes', dto.notes);
    return apiClient.post<Attachment>(this.BASE, formData);
  }

  async delete(attachmentId: string): Promise<ApiResponse<void>> {
    return apiClient.post<void>(`${this.BASE}/${attachmentId}/delete`, {});
  }

  async getByEntity(filter: AttachmentFilter): Promise<ApiResponse<Attachment[]>> {
    const params = new URLSearchParams();
    if (filter.entity_type) params.set('entity_type', filter.entity_type);
    if (filter.entity_id) params.set('entity_id', filter.entity_id);
    if (filter.file_category) params.set('file_category', filter.file_category);
    return apiClient.get<Attachment[]>(`${this.BASE}?${params.toString()}`);
  }

  async getPreviewUrl(attachmentId: string): Promise<ApiResponse<string>> {
    return apiClient.get<string>(`${this.BASE}/${attachmentId}/preview`);
  }

  async getThumbnailUrl(attachmentId: string): Promise<ApiResponse<string>> {
    return apiClient.get<string>(`${this.BASE}/${attachmentId}/thumbnail`);
  }
}
